var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex mt-2 align-center"},[_c('v-simple-checkbox',_vm._g(_vm._b({attrs:{"data-track":"ssl","color":"primary"}},'v-simple-checkbox',_vm.$attrs,false),_vm.$listeners)),_c('span',{staticClass:"grey--text"},[_vm._v(_vm._s(_vm.$t('sources.edit.enforce_ssl')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }